/* eslint-disable @typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../../app/constants/events';
import { setComponentNameFormValidity } from '../../../../../app/package-designer/store/component.actions';

xplenty.directive('componentNameEditor', [
  '$timeout',
  '$rootScope',
  'ngrxStoreService',
  function ($timeout, $rootScope, ngrxStoreService) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./component-name-editor.html'),

      replace: true,

      scope: {
        component: '=',
      },

      link(scope, element, attrs) {
        scope.$watch('formComponentName.$valid', function (valid) {
          $rootScope.$broadcast(EVENTS.DESIGNER_COMPONENT_NAME_VALID, valid);
        });

        $timeout(function () {
          ngrxStoreService.dispatch(
            setComponentNameFormValidity({ isComponentNameFormValid: scope.formComponentName.$valid }),
          );
          $rootScope.$broadcast(
            EVENTS.DESIGNER_COMPONENT_NAME_VALID,
            scope.formComponentName && scope.formComponentName.$valid,
          );

          element.find('.component-name-editor-icon-info').tooltip({
            placement: 'right',
            title:
              'Component name should be unique and start with a letter followed by any number of letters, numbers and underscores.',
          });
        });
      },
    };
  },
]);
